import React from "react";

function QuoteUp(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="91"
      viewBox="0 0 96 91"
      {...props}
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#1440CC" fillRule="nonzero">
          <path d="M22.278 41.983v7.682h19.306V91H0V49.665h.001v-7.682c0-15.599 4.515-27.181 13.42-34.428C19.58 2.542 27.378 0 36.597 0v22.143c-5.004 0-14.32 0-14.32 19.84zm68.736-19.84V0c-9.218 0-17.016 2.542-23.176 7.555-8.905 7.247-13.42 18.83-13.42 34.428V91H96V49.665H76.694v-7.682c0-19.84 9.315-19.84 14.32-19.84z"></path>
        </g>
      </g>
    </svg>
  );
}

export default QuoteUp;
